module.exports = __webpack_public_path__ + "img/delay_0.f124758d.svg";